export default "/images/vendor/flag-icon-css/flags/4x3/mv.svg?f252e4cb6189ffbeb1ed63db451356ad";